/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  equipmentTypeFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('equipmentTypeFilterController', ['$scope', 'lookupTables',
      function ($scope, lookupTables) {
        $scope.componentName = "equipmentTypeFilter";

        $scope.equipmentTypes = lookupTables.equipmentTypes();
        $scope.criteria.allSelectedEquipmentTypes = false;

        $scope.resetFilter = function () {
          $scope.clearEquipmentTypeSelections();
        };

        $scope.clearEquipmentTypeSelections = function () {
          $scope.criteria.selectedEquipmentTypes = null;
          delete $scope.criteria["selectedEquipmentTypes"];
        };

        $scope.removeEquipmentTypeFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#equipmentTypeFilter");
        };

        $scope.$watch("criteria.selectedEquipmentTypes.length", function () {
          if (!$scope.criteria.selectedEquipmentTypes) return;

          $scope.selectedCount = $scope.criteria.selectedEquipmentTypes.length;
          $scope.plural = ($scope.selectedCount === 1) ? "" : "s";
        });

      }])
    .directive('equipmentTypeFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/equipmentTypeFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'equipmentTypeFilterController'
        };
      }]);
//------------------------------------------------------------------------
